<template>
  <div id="system-publish-basic-information">
    <ipub-form ref="basic-information-form" :model="params" :rules="rules">
      <ipub-row :gutter="120">
        <ipub-col :span="4.8">
          <ipub-form-item :label="LANGUAGE[language].publisherLogo" prop="logo">
            <ipub-upload
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('logo', e)
                }
              "
            >
              <div class="upload-content">
                <img
                  v-if="params.logo"
                  :src="`${domain}/${params.logo}`"
                  alt=""
                />
                <ipub-icon v-else type="iconAdd" />
              </div>
            </ipub-upload>
            <div class="font-color ipub-p4">
              Only support .png; File size need to be less than 2MB.
            </div>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="7.2">
          <div>
            <ipub-form-item
              :label="LANGUAGE[language].publisherFullName"
              prop="fullName"
            >
              <ipub-input
                v-model.trim="params.fullName"
                :placeholder="LANGUAGE[language].publisherFullName"
              />
            </ipub-form-item>
          </div>
          <div>
            <ipub-row :gutter="12">
              <ipub-col :span="6">
                <ipub-form-item label="Email" prop="email">
                  <ipub-input v-model.trim="params.email" placeholder="Email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="6">
                <ipub-form-item
                  label="Reviewers Invite Interval Time Limit (days)"
                  prop="reviewLimitDay"
                >
                  <div slot="label" class="mar-b-10 ipub-p2 fw-bd">
                    Reviewers Invite Interval Time Limit (days)
                    <ipub-tooltip
                      class="mar-l-10 lin-h-40"
                      placement="bottom"
                      type="dark"
                    >
                      <div slot="title" style="width: 190px">
                        When inviting reviewers, the [Limited to Invite] label
                        will be displayed if the latest invitation interval is
                        less than the set number of days.
                      </div>
                      <ipub-icon class="ipub-cursor-pointer" type="iconInfo" />
                    </ipub-tooltip>
                  </div>
                  <ipub-input
                    v-model.trim="params.reviewLimitDay"
                    :fixed="0"
                    number
                    placeholder="Please enter the interval at which invitations are allowed."
                  />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="3">
          <ipub-form-item
            :label="LANGUAGE[language].country"
            prop="countryCode"
          >
            <ipub-select
              v-model="params.countryCode"
              :clear="true"
              placeholder="Country"
              search
              @search="countrySearch"
            >
              <ipub-select-option
                v-for="item in countryList"
                :key="'countryList' + item.code"
                :value="item.code"
              >
                {{ item.name }}
                <template v-if="item.otherName"
                  >({{ item.otherName }})
                </template>
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="9">
          <ipub-form-item
            :label="LANGUAGE[language].officialWebsite"
            prop="website"
          >
            <ipub-input
              v-model.trim="params.website"
              :placeholder="LANGUAGE[language].officialWebsite"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="12">
          <ipub-form-item
            :label="LANGUAGE[language].publisherAddress"
            prop="address"
          >
            <ipub-input
              v-model.trim="params.address"
              :placeholder="LANGUAGE[language].publisherAddress"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="conditionsTerms">
            <div slot="label" class="ipub-p2 fw-bd mar-b-10 relative">
              {{ LANGUAGE[language].termsCondition }}
              <template v-if="params.conditionsTerms">
                <ipub-tooltip class="mar-l-10 ipub-c-p" placement="bottomLeft">
                  <div slot="title">Copy File Address</div>
                  <ipub-icon
                    type="iconduplicate"
                    @click="handleCopyAddress(params.conditionsTerms)"
                  />
                </ipub-tooltip>
              </template>
              <div class="right-option">
                <ipub-upload
                  class="ipub-c-p"
                  @change="
                    (e) => {
                      handleUpload('conditionsTerms', e)
                    }
                  "
                >
                  <a class="link-color">Upload</a>
                </ipub-upload>
              </div>
            </div>
            <ipub-upload-input
              :domain="domain"
              :file="params"
              _name="conditionsTermsName"
              _path="conditionsTerms"
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('conditionsTerms', e)
                }
              "
              @delete="delFile('conditionsTerms')"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="useTerms">
            <div slot="label" class="ipub-p2 fw-bd mar-b-10 relative">
              {{ LANGUAGE[language].termsUse }}
              <template v-if="params.useTerms">
                <ipub-tooltip class="mar-l-10 ipub-c-p" placement="bottomLeft">
                  <div slot="title">Copy File Address</div>
                  <ipub-icon
                    type="iconduplicate"
                    @click="handleCopyAddress(params.useTerms)"
                  />
                </ipub-tooltip>
              </template>
              <div class="right-option">
                <ipub-upload
                  class="ipub-c-p"
                  @change="
                    (e) => {
                      handleUpload('useTerms', e)
                    }
                  "
                >
                  <a class="link-color">Upload</a>
                </ipub-upload>
              </div>
            </div>
            <ipub-upload-input
              :domain="domain"
              :file="params"
              _name="useTermsName"
              _path="useTerms"
              class="mar-b-20"
              @change="
                (e) => {
                  handleUpload('useTerms', e)
                }
              "
              @delete="delFile('useTerms')"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item :label="LANGUAGE[language].themeColor" prop="mainColor">
          <ipub-radio-group v-model="params.mainColor">
            <ipub-radio
              v-for="(item, index) in colors"
              :key="'Theme Color' + index"
              :value="item"
            >
              <div
                :style="{ background: item }"
                class="show-color-content"
              ></div>
            </ipub-radio>
            <ipub-radio :value="personalColor">
              <div
                :style="{ background: personalColor }"
                class="show-color-content"
              >
                <input v-model="personalColor" type="color" />
              </div>
            </ipub-radio>
            <font class="link-color ipub-p3">{{
              LANGUAGE[language].customsizeColor
            }}</font>
          </ipub-radio-group>
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item
            :label="LANGUAGE[language].downloadNum"
            prop="downloadNum"
          >
            <ipub-input
              v-model.trim="params.downloadNum"
              :placeholder="LANGUAGE[language].downloadNum"
              number
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item
            :label="LANGUAGE[language].articleNum"
            prop="articleNum"
          >
            <ipub-input
              v-model.trim="params.articleNum"
              :placeholder="LANGUAGE[language].articleNum"
              number
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item :label="LANGUAGE[language].readNum" prop="readNum">
            <ipub-input
              v-model.trim="params.readNum"
              :placeholder="LANGUAGE[language].readNum"
              number
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <div>
        <ipub-form-item
          :label="LANGUAGE[language].basiceInformation"
          prop="info"
        >
          <ipub-textarea
            v-model.trim="params.info"
            :placeholder="LANGUAGE[language].basiceInformation"
          />
        </ipub-form-item>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item :label="LANGUAGE[language].twitter" prop="twitter">
            <ipub-input
              v-model.trim="params.twitter"
              :placeholder="LANGUAGE[language].twitter"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item :label="LANGUAGE[language].facebook" prop="facebook">
            <ipub-input
              v-model.trim="params.facebook"
              :placeholder="LANGUAGE[language].facebook"
            />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item :label="LANGUAGE[language].linkedin" prop="linkedIn">
            <ipub-input
              v-model.trim="params.linkedIn"
              :placeholder="LANGUAGE[language].linkedin"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="12">
          <ipub-form-item
            :label="LANGUAGE[language].copyright"
            prop="copyright"
          >
            <ipub-input
              v-model.trim="params.copyright"
              placeholder="Please enter the content for website copyright"
            />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-form-item label="Page Component Info">
        <ipub-editor
          v-model="params.pageComponentInfo"
          :height="200"
          placeholder="Enter the Page Component Info…"
        />
      </ipub-form-item>
      <ipub-form-item label="Additional Information">
        <ipub-editor
          v-model="params.extraInfo"
          :height="200"
          placeholder="Enter the additional information…"
        />
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <!-- <ipub-button plain
                   style="width:150px"
                   @click="preview"
                   type="primary">{{LANGUAGE[language].preview}}</ipub-button> -->
      <ipub-button
        v-if="
          user.codeList &&
          user.codeList.includes('SYSTEM.PUBLISH.BASIC_INFORMATION.EDIT')
        "
        style="width: 150px"
        type="primary"
        @click="submit"
        >{{ LANGUAGE[language].submit }}
      </ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'

export default main
</script>
